import { ADD_DEPARTMENT, ADD_DEPARTMENT_FAILED, ADD_DEPARTMENT_SUCCESS, DEPARTMENT, DEPARTMENT_FAILED, DEPARTMENT_SUCCESS, UPDATE_DEPARTMENT, UPDATE_DEPARTMENT_FAILED, UPDATE_DEPARTMENT_SUCCESS } from "./actionTypes"

let initialState = {
    department: [],
    addDepartment: "",
    updateDepartment: "",
    loading: false,
    success: false,
    error: ''
}

export const departmentReducer = (state = initialState, action) => {
    switch (action.type) {

        case DEPARTMENT: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case DEPARTMENT_SUCCESS: return {
            ...state,
            department: action.payload,
            loading: false,
            success: true
        }
        case DEPARTMENT_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_DEPARTMENT: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_DEPARTMENT_SUCCESS: return {
            ...state,
            addDepartment: action.payload,
            department: [...state.department, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_DEPARTMENT_FAILED: return {
            ...state,
            addDepartment: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_DEPARTMENT: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_DEPARTMENT_SUCCESS: return {
            ...state,
            updateDepartment: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_DEPARTMENT_FAILED: return {
            ...state,
            updateDepartment: [],
            loading: false,
            success: false,
            error: action.payload
        }

        default: return state
    }
}